<template>
  <div class="recruit-page">
    <div class="recruit-left-menu">
      <el-menu default-active="1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
               :collapse="isCollapse" background-color="#545c64"
               text-color="#fff" @select="handleSelect">
        <div class="toggle-menu-btn" @click="isCollapse = !isCollapse">
          <i v-if="isCollapse" class="el-icon-menu" title="展开"></i>
          <i v-else class="el-icon-s-order" title="折叠"></i>
        </div>
        <el-menu-item index="1">
          <i class="el-icon-edit-outline"></i>
          <span slot="title">职位管理</span>
        </el-menu-item>
        <el-menu-item index="6">
          <i class="el-icon-message"></i>
          <span slot="title" v-if="resumeNum !== 0">
            <el-badge :value="resumeNum" :max="99" :class="{'el-badge-item-expand': !isCollapse, 'el-badge-item-collapse': isCollapse}">
              收到简历
            </el-badge>
          </span>
          <span slot="title" v-else>收到简历</span>
        </el-menu-item>
<!--        <el-menu-item index="2">-->
<!--          <i class="el-icon-s-check"></i>-->
<!--          <span slot="title">推荐牛人</span>-->
<!--        </el-menu-item>-->
        <!--<el-menu-item index="3"> todo 简历列表信息
          <i class="el-icon-search"></i>
          <span slot="title">搜索牛人</span>
        </el-menu-item>-->
        <el-menu-item index="4">
          <i class="el-icon-chat-dot-round"></i>
          <span slot="title">在线沟通</span>
        </el-menu-item>
<!--        <el-menu-item index="5">-->
<!--          <i class="el-icon-user-solid"></i>-->
<!--          <span slot="title">我的资料</span>-->
<!--        </el-menu-item>-->
      </el-menu>
    </div>
    <div class="recruit-right-content">
      <component :is="recruitSubPage"></component>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import JobsManage from './JobsManage'
import RecommendTalents from './RecommendTalents'
import SearchTalents from './SearchTalents'
import RecruitCommunicate from './RecruitCommunicate'
import RecruitMyInfo from './RecruitMyInfo'
import ReceiveResumes from './ReceiveResumes'
export default {
  name: 'Recruit',
  data () {
    return {
      isCollapse: false,
      recruitSubPageIndex: '1',
      resumeNum: 0,
      recruitSubPage: JobsManage
    }
  },
  methods: {
    handleOpen () {

    },
    handleClose () {

    },
    handleSelect (key, keyPath) {
      this.recruitSubPageIndex = key
      switch (key) {
        case '1':
          this.recruitSubPage = JobsManage
          break
        case '2':
          this.recruitSubPage = RecommendTalents
          break
        case '3':
          this.recruitSubPage = SearchTalents
          break
        case '4':
          this.recruitSubPage = RecruitCommunicate
          break
        case '5':
          this.recruitSubPage = RecruitMyInfo
          break
        case '6':
          this.recruitSubPage = ReceiveResumes
          break
        default:
          break
      }
    }
  },
  mounted () {
    if (this.$store.get('user')) {
      this.$http.get(this.$api.getResumeBasicNum.url, {
        userCode: this.$store.get('user').userCode
      }).then(_ => {
        if (_ && _.code === 200 && _.data) {
          this.resumeNum = _.data['resumeSum'] || 0
        }
      })
    }
  }
}
</script>

<style scoped>
  .recruit-page {
    width: 1200px;
    margin: auto;
    background: #ffffff;
    min-height: calc(100vh - 90px);
  }
.recruit-left-menu {
  display: inline-block;
  float: left;
  text-align: left;
  position: relative;
}
  .toggle-menu-btn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
    cursor: pointer;
    border: 1px solid rgb(84, 92, 100);
    border-top: none;
    z-index: 1;
    background: #fff;
    border-bottom-left-radius: 20px;
    text-align: center;
  }
  .toggle-menu-btn:hover {
    color: #409EFF;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 140px;
  }
  .recruit-right-content {
    display: inline-block;
    float: left;
    padding: 20px;
    width: 1010px;
  }
  .el-badge-item-expand {
    line-height: 36px;
    height: 44px;
    margin-top: 4px;
  }
  .el-badge-item-collapse {
    margin-right: 25px;
    width: 65px;
    line-height: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Recruit/Recruit.vue